import { useIdioma } from '../idioma';

/**
 * El emblema de una marca: su logo si lo subió en "Tu identidad"; si no, sus iniciales sobre un color propio,
 * para reconocerla de un vistazo antes de leer el nombre.
 */
const COLORES = [
  { fondo: '#0D0D0D', tinta: '#C8F000' },
  { fondo: '#5A3825', tinta: '#F6F1EA' },
  { fondo: '#123E5E', tinta: '#8ED8FF' },
  { fondo: '#3B1D63', tinta: '#E4CCFF' },
  { fondo: '#5C1A2B', tinta: '#FFD3DC' },
];

const colorDe = (id: string) => COLORES[[...id].reduce((s, c) => s + c.charCodeAt(0), 0) % COLORES.length]!;
const inicialesDe = (nombre: string) =>
  nombre.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!).join('').toUpperCase() || '··';

/** El logo de la marca entre los resultados de "Tu identidad": el de fondo claro o, si no, el primero. */
export function logoDeIdentidad(estilo: unknown): string | null {
  const d = (estilo ?? {}) as { logoUrls?: Array<{ url: string | null; tags?: string[] }>; logoUrl?: string | null };
  const logos = (d.logoUrls ?? []).filter((l) => l.url);
  return (logos.find((l) => l.tags?.some((t) => /claro/i.test(t))) ?? logos[0])?.url ?? d.logoUrl ?? null;
}

/** El logo para un fondo oscuro (etiqueta «oscuro»), o null si la marca no subió esa versión. */
export function logoParaFondoOscuro(estilo: unknown): string | null {
  const d = (estilo ?? {}) as { logoUrls?: Array<{ url: string | null; tags?: string[] }> };
  return (d.logoUrls ?? []).find((l) => l.url && l.tags?.some((t) => /oscuro|negativo|blanco/i.test(t)))?.url ?? null;
}

export function Emblema({ id, nombre, logo, clase = '' }: { id: string; nombre: string; logo?: string | null; clase?: string }) {
  const { t } = useIdioma();
  if (logo) {
    return (
      <span className={`emblema con-logo ${clase}`}>
        <img src={logo} alt={t('Logo de {nombre}', { nombre })} />
      </span>
    );
  }
  const c = colorDe(id || nombre);
  return (
    <span className={`emblema ${clase}`} style={{ background: c.fondo, color: c.tinta }}>
      {inicialesDe(nombre)}
    </span>
  );
}
